module.exports = __webpack_public_path__ + "05fc3c8307cb57e740e8cf381a40242b.MP3";